<ion-content class="modal-border">
  <ion-toolbar>
    <ion-button slot="end" fill="clear" (click)="closeModal()">
      <ion-icon size="large" name="close-circle"></ion-icon>
    </ion-button>
  </ion-toolbar>
  <ion-card class="align-item">
    <!-- <h3> QLD : qldlogistics-aush@lafargeholcim.com </h3>
    <h3> NSW : NSW.RMX.Cartage-adjustments@lafargeholcim.com </h3>
    <h3> VIC/SA : vicconccreteadj@lafargeholcim.com </h3>
    <h3> WA : walogistics-aush@lafargeholcim.com </h3> -->

    <table>
      <thead>
        <tr>
          <th>REGION</th>
          <th>READYMIX</th>
          <th>AGGREGATES</th>
          <th>PHONE</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>QLD</td>
          <td colspan="2">qldlogistics-aush&#64;lafargeholcim.com </td>
          <td>07 3259 1705 / 07 3259 1706</td>
        </tr>
        <tr>
          <td>NSW</td>
          <td>NSW.RMX.Cartage-adjustments&#64;lafargeholcim.com </td>
          <td>compliance-nswaggtransport&#64;lafargeholcim.com </td>
          <td>N/A</td>
        </tr>
        <tr>
          <td>VIC</td>
          <td>vicconcretetransport-aush&#64;lafargeholcim.com</td>
          <td>vicaggregateslogistics&#64;lafargeholcim.com </td>
          <td>N/A</td>
        </tr>
        <tr>
          <td>SA</td>
          <td>vicconcretetransport-aush&#64;lafargeholcim.com</td>
          <td>saaggregateslogistics&#64;lafargeholcim.com </td>
          <td>N/A</td>
        </tr>
        <tr>
          <td>WA</td>
          <td colspan="2">walogistics-aush&#64;lafargeholcim.com</td>
          <td>08 9212 2022</td>
        </tr>
    </table>
  </ion-card>
</ion-content>